<template>
  <div>
    <UserMg></UserMg>
  </div>
</template>

<script>
import UserMg from '../components/UserManage.vue';

export default {
  components: {
    UserMg,
  },
};
</script>